import { render } from "./stepMapping.vue?vue&type=template&id=92533164&scoped=true"
import script from "./stepMapping.vue?vue&type=script&lang=js"
export * from "./stepMapping.vue?vue&type=script&lang=js"

import "./stepMapping.vue?vue&type=style&index=0&id=92533164&scoped=true&lang=css"

import exportComponent from "../../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92533164"]])

export default __exports__